var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAction05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#FF8D56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9883 69.1872L58.983 74.069L48.4471 54.3227L27 54.5487L35 59.4277L28.5795 71.1815C27.9288 72.3715 27.244 74.2992 28.1938 76.0411L39.0932 95.9941C41.0453 99.5695 44.4458 99.5487 46.9082 99.5487H64.3278V78.1644H46.0843L50.9883 69.1872ZM103.835 66.4883L95.1235 50.5406L77.6056 61.2307L86.726 77.9314L76.9221 77.9301V68.1748L66.0162 87.6923L76.9273 107.213L76.9247 97.4503H89.7591C91.0605 97.4503 92.9838 97.1133 93.9336 95.3742L104.832 75.4212C106.782 71.8431 105.066 68.7434 103.835 66.4883ZM67.0959 39.3167L71.9959 48.2953L64.0024 53.1771L85.4482 53.4004L95.9841 33.6513L87.988 38.5345L81.5715 26.7835C80.9195 25.5921 79.681 24 77.7827 24H55.988C52.0811 24 50.3979 27.1232 49.1686 29.3783L40.4576 45.326L57.9755 56.0174L67.0959 39.3167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction05);
export default __webpack_public_path__ + "static/media/action05.61b7b028b72744371be94be07433564e.svg";
export { ForwardRef as ReactComponent };